import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { deepLinkLocalStoreUtil } from '../../utils/deepLinkUtils';

export default function DeepLinkPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const id = searchParams.get('id');
    if (id) {
      deepLinkLocalStoreUtil({newId: id})
      console.log('Saved deepLinkId:', id);
    }
    navigate('/app/home');
  }, [searchParams]);
  return null;
}
